import React from 'react';
import { Box } from '@mui/material';
import { TopBorderPaper } from 'components';

import { UnauthLayout } from './unauth.layout';

interface SuspendServiceLayoutProps {
  children?: any;
}

export const SuspendServiceLayout = ({ children = null }: SuspendServiceLayoutProps) => {
  return (
    <UnauthLayout>
      <Box sx={{ paddingX: 2, paddingTop: 3, paddingBottom: 8 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', padding: 3 }} />

        <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: 400 }}>
          <Box sx={{ width: '100%', maxWidth: (theme) => theme.breakpoints.values.md, position: 'relative' }}>
            <TopBorderPaper>{children}</TopBorderPaper>
          </Box>
        </Box>
      </Box>
    </UnauthLayout>
  );
};
